import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const archiveRateCard = api(async function archiveRateCard({ id }) {
    return mutate(
        gql`
            mutation ArchiveRateCard($id: String!) {
                archiveRateCard(id: $id)
            }
        `,
        { id },
        { returns: "archiveRateCard" }
    )
})
